import * as Sentry from '@sentry/browser';
import commonOptions from './common-options';

export default function sentryInitStandalone(options = {}) {
  Sentry.init({
    ...options,
    ...commonOptions,
  });
}
